import { getAccessToken, getUserPrivileges, isOrgUiEnabled, } from '@thoughtspot/session-service';
import { getIdentityServicePublicUrl, getIdpDomain, getOidcLoginUriFromIssuers, } from '@thoughtspot/system-config-service';
export const IDP_TYPE = {
    SAML: 'SAML2',
    GOOGLE: 'GOOGLE',
    AMAZON: 'AMAZON',
    MICROSOFT: 'MICROSOFT',
    OIDC: 'OIDC',
};
export const getIssuerDomain = () => {
    const iuuser = getOidcLoginUriFromIssuers();
    if (!iuuser)
        return '';
    try {
        const parsedUrl = new URL(iuuser);
        const domain = parsedUrl.origin;
        return domain.endsWith('/') ? domain.slice(0, -1) : domain;
    }
    catch {
        return '';
    }
};
export const getOIDCCallbackUrl = () => {
    return `${getIssuerDomain()}/oauth2/v1/authorize/callback`;
};
export const getOIDCLoginUrl = (idpConnectionId) => {
    return `${getIssuerDomain()}/sso/idps/${idpConnectionId}`;
};
export const getDefaultSamlHeaders = () => {
    return {
        accessToken: `Bearer ${getAccessToken()}`,
        xTsPrivileges: btoa(JSON.stringify(getUserPrivileges())),
        xTsIdpDomain: getIdpDomain(),
    };
};
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["ADD_IDP_BUTTON_SAML"] = "adminSection.authentication.addIDPButtonSaml";
    TranslationsKeys["OIDC_ORGS_LABEL"] = "orgs.organization";
    TranslationsKeys["OIDC_DEFAULT_ORGS_LABEL"] = "oidc_form.defaultOrg.Label";
    TranslationsKeys["OIDC_REDIRECT_URI_LABEL"] = "oidc.IdentityDetails.redirectLabel";
    TranslationsKeys["OIDC_REDIRECT_URI_HELP_TEXT"] = "oidc.IdentityDetails.redirectHelpText";
    TranslationsKeys["OIDC_FORM_HEADER"] = "oidc_form.headerText";
    TranslationsKeys["OIDC_JIT_LABEL"] = "oidc_form.JITLabel";
    TranslationsKeys["OIDC_JIT_TRUE_LABEL"] = "oidc_form.JITTrueLabel";
    TranslationsKeys["OIDC_JIT_FALSE_LABEL"] = "oidc_form.JITFalseLabel";
    TranslationsKeys["OIDC_JIT_HELP_TEXT"] = "oidc_form.JITHelpText";
    TranslationsKeys["OIDC_CONNECTION_NAME_ERROR_TEXT"] = "oidc_form.connectionNameErrorText";
    TranslationsKeys["OIDC_CLIENT_SECRET_ERROR_TEXT"] = "oidc_form.clientSecretErrorText";
    TranslationsKeys["OIDC_CLIENT_ID_ERROR_TEXT"] = "oidc_form.clientIdErrorText";
    TranslationsKeys["OIDC_SCOPES_ERROR_TEXT"] = "oidc_form.scopesErrorText";
    TranslationsKeys["OIDC_ISSUER_ERROR_TEXT"] = "oidc_form.issuerErrorText";
    TranslationsKeys["OIDC_TOKEN_ENDPOINT_ERROR_TEXT"] = "oidc_form.tokenEndpointErrorText";
    TranslationsKeys["OIDC_JWKS_ENDPOINT_ERROR_TEXT"] = "oidc_form.jwksEndpointErrorText";
    TranslationsKeys["OIDC_AUTHORIZATION_ERROR_TEXT"] = "oidc_form.authorizationEndpointErrorText";
    TranslationsKeys["OIDC_USER_INFO_ERROR_TEXT"] = "oidc_form.userInfoEndpointErrorText";
    TranslationsKeys["OIDC_CONNECTION_NAME_LABEL"] = "oidc_form.connectionNameLabel";
    TranslationsKeys["OIDC_CLIENT_SECRET_LABEL"] = "oidc_form.clientSecretLabel";
    TranslationsKeys["OIDC_CALLBACK_URI_LABEL"] = "oidc_form.callbackUriLabel";
    TranslationsKeys["OIDC_CLIENT_ID_LABEL"] = "oidc_form.clientIdLabel";
    TranslationsKeys["OIDC_SCOPES_LABEL"] = "oidc_form.scopesLabel";
    TranslationsKeys["OIDC_ISSUER_LABEL"] = "oidc_form.issuerLabel";
    TranslationsKeys["SAML_LIST_HEADER"] = "adminSection.authentication.samlListHeader";
    TranslationsKeys["OIDC_LIST_HEADER"] = "adminSection.authentication.oidcListHeader";
    TranslationsKeys["ADD_IDP_BUTTON"] = "adminSection.authentication.addIDPButton";
    TranslationsKeys["OIDC_TOKEN_ENDPOINT_LABEL"] = "oidc_form.tokenEndpointLabel";
    TranslationsKeys["OIDC_JWKS_ENDPOINT_LABEL"] = "oidc_form.jwksEndpointLabel";
    TranslationsKeys["OIDC_AUTHORIZATION_LABEL"] = "oidc_form.authorizationEndpointLabel";
    TranslationsKeys["OIDC_USER_INFO_LABEL"] = "oidc_form.userInfoEndpoint";
    TranslationsKeys["OIDC_CONNECTION_NAME_HELP_TEXT"] = "oidc_form.connectionNameHelpText";
    TranslationsKeys["OIDC_CLIENT_SECRET_HELP_TEXT"] = "oidc_form.clientSecretHelpText";
    TranslationsKeys["OIDC_CLIENT_ID_HELP_TEXT"] = "oidc_form.clientIdHelpText";
    TranslationsKeys["OIDC_SCOPES_HELP_TEXT"] = "oidc_form.scopesHelpText";
    TranslationsKeys["OIDC_ISSUER_HELP_TEXT"] = "oidc_form.issuerHelpText";
    TranslationsKeys["OIDC_TOKEN_ENDPOINT_HELP_TEXT"] = "oidc_form.tokenEndpointHelpText";
    TranslationsKeys["OIDC_JWKS_ENDPOINT_HELP_TEXT"] = "oidc_form.jwksEndpointHelpText";
    TranslationsKeys["OIDC_AUTHORIZATION_HELP_TEXT"] = "oidc_form.authorizationEndpointHelpText";
    TranslationsKeys["OIDC_USER_INFO_HELP_TEXT"] = "oidc_form.userInfoEndpointHelpText";
    TranslationsKeys["SAML_CONT_HEADER"] = "saml.container.header";
    TranslationsKeys["ADD_SAML_CONT_BUTTON_LABEL"] = "add.saml.connection.button.label";
    TranslationsKeys["ADD_BUTTON"] = "saml.IdentityProvider.addButton";
    TranslationsKeys["SAML_CONFIG_TEXT"] = "saml.IdentityProvider.config.text";
    TranslationsKeys["SAML_CONFIG_MESSAGE"] = "saml.IdentityProvider.config.message";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_HEADER"] = "saml.ThoughtSpotToIDP.add.headerTitle";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_PI"] = "saml.ThoughtSpotToIDP.ParagraphI";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_PII"] = "saml.ThoughtSpotToIDP.ParagraphII";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_PIII"] = "saml.ThoughtSpotToIDP.ParagraphIII";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_ACS_URL"] = "saml.ThoughtSpotToIDP.acsUrl";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_AUDIENCE_URI"] = "saml.ThoughtSpotToIDP.audienceUri";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_METADATA_LABEL"] = "saml.ThoughtSpotToIDP.SAML.Metadata.label";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_DOWNLOAD_METADATA"] = "saml.ThoughtSpotToIDP.Download.Metadata";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_SAVE_BUTTON"] = "saml.ThoughtSpotToIDP.Save.Button";
    TranslationsKeys["SAML_THOUGHT_SPOT_TO_IDP_COPIED_MSG"] = "saml.ThoughtSpotToIDP.Copied.Msg";
    TranslationsKeys["DETAILS_HEADER"] = "saml.IdentityDetails.headerTitle";
    TranslationsKeys["NAME_LABEL"] = "saml.IdentityDetails.label.ConnectionName";
    TranslationsKeys["NAME_LABEL_HELPTEXT"] = "saml.IdentityDetails.ConnectionName.helpText";
    TranslationsKeys["METADATA_LABEL"] = "saml.IdentityDetails.label.MetadataXML";
    TranslationsKeys["METADATA_LABEL_HELPTEXT"] = "saml.IdentityDetails.MetadataXML.helpText";
    TranslationsKeys["CERTIFICATE_LABEL"] = "saml.IdentityDetails.label.Certificate";
    TranslationsKeys["CERTIFICATE_LABEL_HELPTEXT"] = "saml.IdentityDetails.Certificate.helpText";
    TranslationsKeys["CERTIFICATE_ERROR_MSG"] = "saml.IdentityDetails.Certificate.errorMsg";
    TranslationsKeys["ISSUER_LABEL"] = "saml.IdentityDetails.label.Issuer";
    TranslationsKeys["ISSUER_LABEL_HELPTEXT"] = "saml.IdentityDetails.Issuer.helpText";
    TranslationsKeys["SSO_LABEL"] = "saml.IdentityDetails.label.sso";
    TranslationsKeys["SSO_LABEL_HELPTEXT"] = "saml.IdentityDetails.sso.helpText";
    TranslationsKeys["ADVANCED_CONFIG"] = "saml.IdentityDetails.Advanced.configuration";
    TranslationsKeys["BINDING_LABEL"] = "saml.IdentityDetails.label.binding";
    TranslationsKeys["BINDING_LABEL_HELPTEXT"] = "saml.IdentityDetails.binding.helpText";
    TranslationsKeys["REQ_ALGO_LABEL"] = "saml.IdentityDetails.label.requestSignAlgo";
    TranslationsKeys["REQ_ALGO_LABEL_HELPTEXT"] = "saml.IdentityDetails.requestSignAlgo.helpText";
    TranslationsKeys["RES_ALGO_LABEL"] = "saml.IdentityDetails.label.responseSignAlgo";
    TranslationsKeys["RES_ALGO_LABEL_HELPTEXT"] = "saml.IdentityDetails.responseSignAlgo.helpText";
    TranslationsKeys["SKEWTIME_LABEL"] = "saml.IdentityDetails.label.skewTime";
    TranslationsKeys["SKEWTIME_LABEL_HELPTEXT"] = "saml.IdentityDetails.skewTime.helpText";
    TranslationsKeys["DOWNLOAD_META"] = "saml.IdentityDetails.downloadMeta";
    TranslationsKeys["REMOVE_PRO_DEC"] = "saml.IdentityDetails.remove.provider.dec";
    TranslationsKeys["REMOVE_PRO_BUTTON"] = "saml.IdentityDetails.remove.provider.button";
    TranslationsKeys["REMOVE_PRO_TITLE"] = "saml.IdentityDetails.remove.provider.title";
    TranslationsKeys["ACTIVE"] = "saml.IdentityDetails.active";
    TranslationsKeys["INACTIVE"] = "saml.IdentityDetails.inactive";
    TranslationsKeys["ENABLE_MESSAGE"] = "saml.IdentityDetails.enableMessage";
    TranslationsKeys["DISABLE_MESSAGE"] = "saml.IdentityDetails.disableMessage";
    TranslationsKeys["BUTTON_ENABLE"] = "saml.IdentityDetails.buttonEnable";
    TranslationsKeys["BUTTON_DISABLE"] = "saml.IdentityDetails.buttonDisable";
    TranslationsKeys["ALERT_ENABLE_TITLE"] = "saml.IdentityDetails.alertEnableTitle";
    TranslationsKeys["ALERT_DISABLE_TITLE"] = "saml.IdentityDetails.alertDisableTitle";
    TranslationsKeys["ENABLED"] = "saml.IdentityDetails.enabled";
    TranslationsKeys["DISABLED"] = "saml.IdentityDetails.disabled";
    TranslationsKeys["CANCEL"] = "CANCEL";
    TranslationsKeys["REMOVE"] = "REMOVE";
    TranslationsKeys["SUBMIT"] = "SUBMIT";
    TranslationsKeys["CONTINUE"] = "continue";
    TranslationsKeys["EDIT"] = "EDIT";
    TranslationsKeys["MAP_HEADER"] = "saml.mapAttribute.header";
    TranslationsKeys["MAP_SUBHEADER"] = "saml.mapAttribute.subheader";
    TranslationsKeys["MAP_SUBHEADER2"] = "saml.mapAttribute.subheader2";
    TranslationsKeys["MAP_SUBHEADER3"] = "saml.mapAttribute.subheader3";
    TranslationsKeys["MAP_SUBHEADER_OIDC"] = "saml.mapAttribute.oidcsubheader";
    TranslationsKeys["MAP_COLUMN1"] = "saml.mapAttribute.column1";
    TranslationsKeys["OIDC_MAP_COLUMN1"] = "oidc.mapAttribute.column1";
    TranslationsKeys["MAP_COLUMN2"] = "saml.mapAttribute.column2";
    TranslationsKeys["SAVE_CONTINUE"] = "saml.mapAttribute.continue";
    TranslationsKeys["BACK"] = "BACK";
    TranslationsKeys["ENABLEBUTTON"] = "saml.thoughtspotToIdp.enableButton";
    TranslationsKeys["SAVE_CONFIG_ENABLE"] = "saml.thoughtspotToIdp.saveConfigurationEnabling";
    TranslationsKeys["CREATE_CONNECTION_ERROR"] = "saml.createConnection.errorMessage";
    TranslationsKeys["UPDATE_CONNECTION_ERROR"] = "saml.updateConnection.errorMessage";
    TranslationsKeys["MAP_ATTRIBUTE_ERROR"] = "saml.mapAttribute.errorMessage";
    TranslationsKeys["LIST_RETRIEVE_ERROR"] = "saml.connectionList.listRetrieveError";
    TranslationsKeys["IAM_V2_MIGRATION_AUTOMATION_BANNER_CONTENT"] = "adminSection.authentication.iamV2MigrationAutomationBannerContent";
    TranslationsKeys["IAM_V2_MIGRATION_AUTOMATION_BANNER_SUB_CONTENT"] = "adminSection.authentication.iamV2MigrationAutomationBannerSubContent";
    TranslationsKeys["IAM_V2_MIGRATION_AUTOMATION_CONFIRMATION"] = "adminSection.authentication.iamV2MigrationConfirmation";
    TranslationsKeys["IAM_V2_MIGRATION_AUTOMATION_CONFIRMATION_MODAL_TITLE"] = "adminSection.authentication.confirmDelete.iamV2MigrationConfirmation";
    TranslationsKeys["MODAL_OK"] = "modal.ok";
    TranslationsKeys["SAVE_CONFIRMATION_LOADING_MESSAGE"] = "tscli.ui.saveconfirmation.loading.message";
    TranslationsKeys["DUPLICATE_NAME_ERROR"] = "saml.createConnection.duplicateName";
    TranslationsKeys["OIDC_CREATE_CONNECTION_ERROR"] = "oidc.createConnection.errorMessage";
    TranslationsKeys["OIDC_UPDATE_CONNECTION_ERROR"] = "oidc.updateConnection.errorMessage";
    TranslationsKeys["OIDC_DUPLICATE_NAME_ERROR"] = "oidc.createConnection.duplicateName";
    TranslationsKeys["OIDC_LIST_RETRIEVE_ERROR"] = "OIDC.connectionList.listRetrieveError";
    TranslationsKeys["SAML_STEP_INDICATOR_FIRST_LABEL"] = "saml.IdentityDetails.firstStepLabel";
    TranslationsKeys["CONNECTION_DISABLE_ERROR"] = "adminSection.authentication.connection.disable.error";
})(TranslationsKeys || (TranslationsKeys = {}));
export const bindingList = [
    {
        options: [
            {
                label: 'HTTP-POST',
                id: 'POST',
            },
        ],
    },
];
export const noMatchOpType = [
    {
        options: [
            {
                label: 'Create new User (JIT)',
                id: 'JIT',
            },
            {
                label: 'Redirect to sign-in page',
                id: 'REDIRECT',
            },
        ],
    },
];
export const algoTypes = [
    {
        options: [
            {
                label: 'SHA-256',
                id: 'SHA-256',
            },
            {
                label: 'SHA-1',
                id: 'SHA-1',
            },
        ],
    },
];
export const defaultFormValues = {
    name: '',
    type: 'SAML2',
    status: 'ACTIVE',
    sso: {
        url: '',
        binding: 'POST',
    },
    issuer: '',
    certData: {
        x5c: '',
    },
    requestSignatureAlgorithm: 'SHA-256',
    responseSignatureAlgorithm: 'SHA-256',
    maxClockSkew: 86400,
    mappings: {
        username: 'subjectNameId',
        email: '',
        displayName: '',
        locale: '',
        timezone: '',
        roles: '',
        orgs: '',
        defaultOrg: '',
        groupsWithOrg: '',
    },
    connectionName: '',
    scopes: 'profile email openid',
    claims: '',
    IDPClientId: '',
    clientSecret: '',
    authorizationEndpoint: '',
    tokenEndpoint: '',
    userinfoEndpoint: '',
    jwksEndpoint: '',
    autocreateuser: true,
};
export const mapAttributeFields = [
    {
        id: 'username',
        fieldName: 'saml.mapAttribute.field.username',
        fieldStatus: false,
        mandatory: true,
    },
    {
        id: 'email',
        fieldName: 'saml.mapAttribute.field.email',
        fieldStatus: false,
        mandatory: true,
    },
    {
        id: 'displayName',
        fieldName: 'saml.mapAttribute.field.displayName',
        fieldStatus: false,
        mandatory: false,
    },
    {
        id: 'roles',
        fieldName: 'saml.mapAttribute.field.roles',
        fieldStatus: false,
        mandatory: false,
    },
    {
        id: 'orgs',
        fieldName: TranslationsKeys.OIDC_ORGS_LABEL,
        fieldStatus: false,
        mandatory: false,
    },
    {
        id: 'defaultOrg',
        fieldName: TranslationsKeys.OIDC_DEFAULT_ORGS_LABEL,
        fieldStatus: false,
        mandatory: false,
    },
];
export const getSubDomainIfOrgEnabled = () => {
    if (!isOrgUiEnabled()) {
        return '';
    }
    const url = new URL(window.location.href);
    const domains = url.hostname.split('.');
    if (domains[1] === getIdpDomain()) {
        return `${domains[0]}_`;
    }
    return '';
};
export const IDP_LIST = [
    {
        type: IDP_TYPE.GOOGLE,
        image: '/resources/img/google.svg',
        title: 'Google',
    },
    {
        type: IDP_TYPE.MICROSOFT,
        image: '/resources/img/microsoft.svg',
        title: 'Microsoft',
    },
    {
        type: IDP_TYPE.AMAZON,
        image: '/resources/img/amazon.png',
        title: 'Amazon',
    },
    {
        type: IDP_TYPE.OIDC,
        image: '/resources/img/oidc.png',
        title: 'OIDC',
    },
    {
        type: IDP_TYPE.SAML,
        image: '/resources/img/saml2.png',
        title: 'SAML 2.0',
    },
];
export const getIdentityV2PublicUrl = () => {
    const IDENTITY_PUBLIC_URL = getIdentityServicePublicUrl() ||
        'https://identity.dataplane-public.thoughtspotdev.cloud/v1';
    return `${IDENTITY_PUBLIC_URL}/public`;
};
export const OIDC_CALLBACK_URI = 'https://identity.thoughtspotdevlogin.cloud/oauth2/v1/authorize/callback';
export const OIDC_REDIRECT_URI = 'https://identity.thoughtspotdevlogin.cloud/sso/idps/';
//# sourceMappingURL=constant.js.map